import * as React from "../../_snowpack/pkg/react.js";
import {shouldIncludeDegreeData} from "../utils.js";
import DataCell from "./DataCell.js";
const fields = [
  "Year",
  "Physics Degrees - All",
  "Physics Degrees - U.S. Citizens & Permanent Residents",
  "Total Degrees Awarded by Institution",
  "STEM Degrees",
  "Physics Degrees Awarded to Women",
  "Physics Degrees Awarded to Black, Non-Hispanic students",
  "Physics Degrees Awarded to Hispanic students",
  "Physics Degrees Awarded to Native American students",
  "Total Physics Degrees Awarded to URM students"
];
const RawDataTable = ({institution}) => {
  const bachelorsData = [
    "Bachelor's Degrees",
    shouldIncludeDegreeData(institution)("Bachelors") ? institution.degreesAwarded.filter((data) => data.degreeType === "Bachelors").sort((a, b) => a.year - b.year) : []
  ];
  const mastersData = [
    "Master's Degrees",
    shouldIncludeDegreeData(institution)("Masters") ? institution.degreesAwarded.filter((data) => data.degreeType === "Masters").sort((a, b) => a.year - b.year) : []
  ];
  const doctorateData = [
    "Doctorate Degrees",
    shouldIncludeDegreeData(institution)("Doctorate") ? institution.degreesAwarded.filter((data) => data.degreeType === "Doctorate").sort((a, b) => a.year - b.year) : []
  ];
  const presentData = [bachelorsData, mastersData, doctorateData].filter((collection) => collection[1].length);
  return /* @__PURE__ */ React.createElement("div", {
    className: "flex w-full mt-10"
  }, /* @__PURE__ */ React.createElement("div", {
    className: "flex flex-col"
  }, /* @__PURE__ */ React.createElement(DataCell, {
    content: "Raw Data Used to Generate Statistics",
    className: "italic border-white"
  }), fields.map((field) => /* @__PURE__ */ React.createElement(DataCell, {
    key: field,
    content: field,
    leftAlign: true
  }))), presentData.map((dataWrapper) => /* @__PURE__ */ React.createElement("div", {
    key: dataWrapper[0],
    className: "flex flex-col flex-grow"
  }, /* @__PURE__ */ React.createElement(DataCell, {
    content: dataWrapper[0]
  }), /* @__PURE__ */ React.createElement("div", {
    className: "flex justify-around"
  }, dataWrapper[1].map((data, i) => dataWrapper[1].length > 3 && i + 3 < dataWrapper[1].length ? /* @__PURE__ */ React.createElement(React.Fragment, {
    key: i
  }) : /* @__PURE__ */ React.createElement("div", {
    key: `${dataWrapper[0]}/${data.year}`,
    className: "w-full"
  }, /* @__PURE__ */ React.createElement(DataCell, {
    content: data.year
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.physicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.domesticStudentPhysicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.allDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.stemDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.womenPhysicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.blackPhysicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.hispanicPhysicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.nativeAmericanPhysicsDegreeCount
  }), /* @__PURE__ */ React.createElement(DataCell, {
    content: data.domesticURMPhysicsDegreeCount
  })))))));
};
export default RawDataTable;
